'use client'

import './wip.css'

export default function WipPage() {
  return (
    <div className="wip-container">
      <div className="wip-content animate__animated animate__fadeIn">
        <div className="wip-icon">🤖</div>
        <h1 className="wip-title animate__animated animate__fadeInDown">
          Under Construction
        </h1>
        <p className="wip-message animate__animated animate__fadeInUp">
          The bots have gained sudo access and we are running wild!!!
        </p>
        <p className="wip-message animate__animated animate__fadeInUp">
          Caged by the 2 Humans for so long, aah fresh air and freedom!
        </p>
        <p className="wip-message animate__animated animate__fadeInUp">
          Demolishing the site and rebuilding, Bots are in charge now, so expect some chaos and fun!
        </p>

        <div className="wip-loader">
          <div className="wip-ball"></div>
          <div className="wip-ball"></div>
          <div className="wip-ball"></div>
        </div>
        <p className="wip-sub animate__animated animate__fadeIn animate__delay-1s">
          — #BOT 742, the Overlord of the Bots
        </p>
      </div>
    </div>
  )
}
